import React from "react";
import moment from "moment";
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HeadingH3 from '../../UI/Headings/HeadingH3/HeadingH3';

const roundTripHeader = props => {

  const dateFull = moment(props.date, "DD-MM-YYYY").format("DD MMM, ddd");
  const arrivalDateFull = moment(props.arrivalDate, 'DD-MM-YYYY').format('DD MMM, ddd');

  return (
    <div className={`u-flex justify-content-between align-items-center mb-3`}>
      <div>
        <HeadingH3 size={13} weight="Medium" color="Dark">{props.type}</HeadingH3>
      </div>
      <div className={`u-flex align-items-center`}>
        <span className={`mr-1 u-cursorPointer`} onClick={props.prev}>
          <span className={`u-inlineBlock u-transformRotate90`}><FontAwesomeIcon icon="angle-down" color="#666" size="1x" /></span>
        </span>
        <div className={`u-fontSize13 u-fontWeightMedium u-textColorDark`}>{props.type === "Departure Flights" ? <span>{dateFull}</span> : <span>{arrivalDateFull}</span>}</div>
        <span className={`ml-1 u-cursorPointer`} onClick={props.next}>
          <span className={`u-inlineBlock u-transformRotate270`}><FontAwesomeIcon icon="angle-down" color="#666" size="1x" /></span>
        </span>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    date: state.flights.departDate,
    arrivalDate: state.flights.arrivalDate,
    travellers: state.flights.totalTravellers,
    cityName: state.flights.cityName,
    flightCode: state.flights.flightCode
  }
}

export default connect(mapStateToProps)(roundTripHeader);



// WEBPACK FOOTER //
// ./src/components/Flight/RoundTripHeader/RoundTripHeader.js